import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import { useSignoutMutation } from "../../store/api/authApi";
import { useSession } from "../Hooks/UserHooks";
import avatar from "../../assets/images/users/user-dummy-img.jpg";
import { SigninResponse } from "../../interfaces";
import { getShortenName } from "../../services";
import { logout } from "../../store/slices/authSlice";
import { AccountState } from "../../store/slices/accountSlice";
import { persistor } from "../../store";

export const ProfileDropdown = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { session } = useSession();
  const { t, i18n } = useTranslation();

  const [signout, { isLoading: isSigningOut }] = useSignoutMutation();

  const profile = useSelector(
    (state: { account: AccountState }) => state.account.userProfile,
  );

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);

  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  const handleSignout = async () => {
    if (session && session.refreshToken) {
      try {
        await signout({
          refreshToken: (session as SigninResponse)?.refreshToken,
        }).unwrap();
      } catch (err) {
      } finally {
        dispatch(logout());
        localStorage.removeItem("session");
        await persistor.purge();
        history.replace("/login");
      }
    }
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn">
          <span className="d-flex align-items-center ">
            <img
              className="rounded-circle header-profile-user"
              src={profile?.profilePhoto || avatar}
              alt="Header Avatar"
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {i18n.language === "ar"
                  ? getShortenName(profile?.name.ar)
                  : getShortenName(profile?.name.en)}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {i18n.language === "ar"
                  ? profile?.role?.name?.ar
                  : profile?.role?.name?.en}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-end"
          style={{ textAlign: "initial" }}
        >
          <h6 className="dropdown-header">
            {t("welcome")}{" "}
            {i18n.language === "ar"
              ? getShortenName(profile?.name.ar)
              : getShortenName(profile?.name.en)}
            !
          </h6>
          <Link to="/settings">
            <DropdownItem style={{ textAlign: "initial" }}>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">{t("settings")}</span>
            </DropdownItem>
          </Link>
          <DropdownItem
            onClick={handleSignout}
            style={{ textAlign: "initial" }}
          >
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              {t("signout")}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};
